import React from 'react'
import AdminNav from './AdminNav'

export default function Admin() {
  return (
    <div className='container-fluid'>
<AdminNav/>

    </div>
  )
}
